import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Tag } from '@/typings/user';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  tag: {
    type: Object as PropType<Tag>,
    required: true,
  },
  style: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center justify-center h-4 px-1 py-0 font-bold rounded w-min text-2xs whitespace-nowrap",
    style: _normalizeStyle({
      color: __props.tag.TextColor,
      background: __props.tag.BackgroundColor,
      ...__props.style,
    })
  }, [
    _createTextVNode(_toDisplayString(__props.tag.Text) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})